// extracted by mini-css-extract-plugin
export default {"rootPdf":"pdfViewer_rootPdf__rYJsY","pagging":"pdfViewer_pagging__IhX7Z"};